export const LANG = 'lang'; // 多语言key
